module.exports = __webpack_public_path__ + "img/valleyball.abb41965.jpg";